module.exports = __webpack_public_path__ + "media/images/download-icon-265428ad.png";